export const USER_ROLES = ['OWNER', 'ADMIN'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const CONTACT_METHODS = ['PHONE', 'TEXT', 'EMAIL'] as const;
export type ContactMethod = (typeof CONTACT_METHODS)[number];

export const QUOTE_STATUSES = ['DRAFT', 'SENT', 'ACCEPTED', 'DECLINED', 'EXPIRED'] as const;
export type QuoteStatus = (typeof QUOTE_STATUSES)[number];

export const JOB_STATUSES = [
  'SCHEDULED',
  'IN_PROGRESS',
  'COMPLETED',
  'SKIPPED',
  'CANCELLED',
] as const;
export type JobStatus = (typeof JOB_STATUSES)[number];

export const INVOICE_STATUSES = ['DRAFT', 'OPEN', 'PARTIALLY_PAID', 'PAID', 'VOID'] as const;
export type InvoiceStatus = (typeof INVOICE_STATUSES)[number];

export const PAYMENT_METHODS = [
  'CASH',
  'CHECK',
  'CARD_EXTERNAL',
  'BANK_TRANSFER',
  'OTHER',
] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const RECURRENCE_TYPES = ['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'CUSTOM_DAYS'] as const;
export type RecurrenceType = (typeof RECURRENCE_TYPES)[number];

export const RECURRING_STATUSES = ['ACTIVE', 'PAUSED', 'ENDED'] as const;
export type RecurringStatus = (typeof RECURRING_STATUSES)[number];

export const ATTACHMENT_CATEGORIES = [
  'PROPERTY_PHOTO',
  'BEFORE_PHOTO',
  'AFTER_PHOTO',
  'QUOTE_ATTACHMENT',
  'INVOICE_ATTACHMENT',
  'OTHER',
] as const;
export type AttachmentCategory = (typeof ATTACHMENT_CATEGORIES)[number];

/** Session lifetime. Field use means long sessions; 30 days with rolling refresh. */
export const SESSION_TTL_SECONDS = 60 * 60 * 24 * 30;
export const SESSION_COOKIE_NAME = 'bc_session';
export const CSRF_COOKIE_NAME = 'bc_csrf';
export const CSRF_HEADER_NAME = 'x-csrf-token';

/** Recurring job generation look-ahead. The plan requires at least 30 days. */
export const RECURRENCE_LOOKAHEAD_DAYS = 45;

/** Upload limits (R2). */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ALLOWED_UPLOAD_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'application/pdf',
] as const;
